export const LOAD_WISHLISTS_START = "LOAD_WISHLIST_NAMES_START";
export const LOAD_WISHLISTS_SUCCESS = "LOAD_WISHLIST_NAMES_SUCCESS";
// TODO: Remove this action when showComments moves to the component

export const LOAD_WISHLIST_DETAILS_POST_PROCESS = "LOAD_WISHLIST_DETAILS_SUCCESS";
export const SELECT_WISHLIST = "SELECT_WISHLIST";

export const SAVE_COMMENT = "SAVE_COMMENT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const DELETE_WISHLIST = "DELETE_WISHLIST";
export const SET_ADD_ALL_CLICKED = "WISHLIST_SET_ADD_ALL_CLICKED";
export const CHANGE_QUANTITY = "CHANGE_QUANTITY";
export const UPDATE_WISHLIST_ENTRY = "UPDATE_WISHLIST_ENTRY";
export const RENAME_WISHLIST = "RENAME_WISHLIST";
export const SAVE_COMMENT_ITEM = "SAVE_COMMENT_ITEM";
export const SHOW_COMMENTS = "SHOW_COMMENTS";
export const COPY_WISHLIST_STATUS_PARAM = "copySuccess";
export const REMOVED_ITEMS = "itemsRemoved";
